import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_ds_storage_control_partners_widgetService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { integration_name?: string, $top?: number, $skip?: number }): Promise<{ result?: { Direction?: string, Count?: number }[], totalCount?: number }> {

    let url = `${environment.backendUrl}api/FootPrintApiManager/datasources/ds_storage_control_partners_widget/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
}

